export default {

    initialerrorstate: {
        first_name: {
            errorstate: false,
            errortext: ""
        },
        last_name: {
            errorstate: false,
            errortext: ""
        },
        email: {
            errorstate: false,
            errortext: ""
        },
        number: {
            errorstate: false,
            errortext: ""
        },
        cvv: {
            errorstate: false,
            errortext: ""
        },
        month: {
            errorstate: false,
            errortext: ""
        },
        year: {
            errorstate: false,
            errortext: ""
        },
        address1: {
            errorstate: false,
            errortext: ""
        },
        address2: {
            errorstate: false,
            errortext: ""
        },
        phone_number: {
            errorstate: false,
            errortext: ""
        },
        city: {
            errorstate: false,
            errortext: ""
        },
        state: {
            errorstate: false,
            errortext: ""
        },
        zip: {
            errorstate: false,
            errortext: ""
        },
        country: {
            errorstate: false,
            errortext: ""
        },
        memberno: {
            errorstate: false,
            errortext: ""
        },
        MonthSelect: {
            errorstate: false,
            errortext: ""
        },
        YearSelect: {
            errorstate: false,
            errortext: ""
        },
        shipping_address1: {
            errorstate: false,
            errortext: ""
        },
        shipping_address2: {
            errorstate: false,
            errortext: ""
        },
        shipping_phone_number: {
            errorstate: false,
            errortext: ""
        },
        shipping_city: {
            errorstate: false,
            errortext: ""
        },
        shipping_state: {
            errorstate: false,
            errortext: ""
        },
        shipping_zip: {
            errorstate: false,
            errortext: ""
        },
        shipping_country: {
            errorstate: false,
            errortext: ""
        },
        MonthAndYear: {
            errorstate: false,
            errortext: ""
        }
    }
}